export default {
  path: 'subscriptions',
  name: 'vendor',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "vendor-show-subscriptions" */ './Subscriptions')
}
